import { render, staticRenderFns } from "./wtAddKeywords.component.vue?vue&type=template&id=945ff6c2&"
import script from "./wtAddKeywords.component.vue?vue&type=script&lang=js&"
export * from "./wtAddKeywords.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports